export class Cookie {
  static setOrganize = (company: string, channel: string, sale: number, center: number) => {
    localStorage.setItem('orgCompany', company);
    localStorage.setItem('orgChannel', channel);
    localStorage.setItem('orgSale', sale.toString());
    localStorage.setItem('orgCenter', center.toString());
  };

  static getOrganize = () => {
    return {
      company: localStorage.getItem('orgCompany'),
      channel: localStorage.getItem('orgChannel'),
      sale: Number(localStorage.getItem('orgSale')),
      center: Number(localStorage.getItem('orgCenter')),
    };
  };

  static removeOrganize = () => {
    localStorage.removeItem('orgCompany');
    localStorage.removeItem('orgChannel');
    localStorage.removeItem('orgSale');
    localStorage.removeItem('orgCenter');
  };
}
